export default __webpack_public_path__ + "static/media/social-media.35d34114.jpg";